<template>
  <div class="">
    <div class="">
    <!-- click button to toggle showing the menu -->
      <button
        @click.prevent.stop="showPriceMenu = !showPriceMenu"
        class="flex px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-gray-800 hover:bg-gray-500 focus:outline-none focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-700"
      >
        <span class="w-5 h-5 mr-2">
        <IconCog></IconCog>
        </span>
        <span>
        <svg
          :class="{'rotate-180': showPriceMenu}"
          class="inline-block h-5 w-5 relative transform rotate-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"/></svg>
        </span>
      </button>
    </div>
    <div
      :class="{ hidden: !showPriceMenu }"
      class="origin-top-right absolute z-10 right-0 mt-2 w-auto rounded-md shadow-lg"
    >
      <!-- this is the menu-->
      <div class="rounded-md bg-white shadow-xs">
        <div class="py-1">
          <button
            @click.prevent.stop="duplicatePrice"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Duplicate price</button>
          <button
            @click.prevent.stop="deletePrice"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Delete price</button>
          <button
            @click.prevent.stop="exportPrice"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Export price</button>
          <button
            @click.prevent.stop="importPrice"
            class="block w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >Import price</button>
          <button
            class="hidden w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 cursor-not-allowed"
          >Duplicate into an exististing project</button>
          <button
            class="hidden w-full px-4 py-2 text-left text-sm leading-5 whitespace-no-wrap text-gray-700 hover:bg-gray-200 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900 cursor-not-allowed"
          >Duplicate into a new project</button>
        </div>
        <input type="file" class="hidden" @change="onFileChange" ref="fileInput" />
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import IconCog from '@/components/icons/IconCog';

export default {
  name: 'PriceMenu',
  components: {
    IconCog
  },
  data() {
    return {
      showPriceMenu: false
    };
  },
  computed: {
    ...mapState('prices', {
      price: 'price'
    })
  },
  methods: {
    duplicatePrice() {
      this.hidePriceMenu()
      this.$emit('duplicatePrice')
    },
    deletePrice() {
      if(window.confirm('Are you sure?')){
        this.$emit('delete-price')
      }
      this.hidePriceMenu()
    },
    onFileChange(e){
      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      files.forEach(file => {
        let reader = new FileReader();
        reader.onload = (e) => {
          let price = JSON.parse(e.target.result)
          this.$store.dispatch('prices/addRowsToPrice', price.rows)
        };
        reader.readAsText(file);
      })
    },
    importPrice(){
      this.$refs.fileInput.click()
    },
    exportPrice(){
      let now = new Date()
      let filename = this.price.name.replace(/\s+/g, '-')
      filename = filename + '-' + this.price.id + '-'
      filename = filename + this.formatDate(now)
      var a = document.createElement("a");
      var file = new Blob([JSON.stringify(this.price)], {type: 'text/plain'});
      a.href = URL.createObjectURL(file);

      a.download = filename + '.json';
      a.click();
    },
    formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-')
    },
    hidePriceMenu() {
      this.showPriceMenu = false
    }
  },
  created() {
    window.addEventListener('click', this.hidePriceMenu)
  },
  destroyed() {
    window.removeEventListener('click', this.hidePriceMenu)
  }
};
</script>
